(() => {
  const cfg = window.MTD || {};
  const root = (cfg.rootUrl || '/').endsWith('/') ? (cfg.rootUrl || '/') : `${cfg.rootUrl}/`;

  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;'
  })[char]);

  const equalizeHeroButtons = (scope = document) => {
    scope.querySelectorAll('[data-equal-hero-buttons]').forEach((group) => {
      const buttons = [...group.querySelectorAll('.mtd-cta')];
      if (buttons.length < 2) {
        buttons.forEach((button) => { button.style.width = ''; });
        return;
      }

      buttons.forEach((button) => { button.style.width = ''; });
      const widest = Math.ceil(Math.max(...buttons.map((button) => button.getBoundingClientRect().width)));
      buttons.forEach((button) => {
        button.style.width = `${widest}px`;
        button.style.maxWidth = '100%';
      });
    });
  };

  const formatMoney = (cents) => {
    const amount = Math.round(Number(cents || 0) / 100);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: cfg.currency || 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
    } catch (e) {
      return `$${amount}`;
    }
  };

  const stripPriceDecimals = (value = '') => String(value)
    .replace(/([.,])\d{1,2}(?=\s*(?:[A-Z]{3})?$)/i, '');

  const formatPredictivePrice = (value = '') => {
    let whole = stripPriceDecimals(value)
      .replace(/\bUSD\b/gi, '')
      .trim();
    if (!whole) return '';
    if (whole.includes('$')) return whole;
    return `$${whole}`;
  };

  const updateCartCount = async () => {
    try {
      const response = await fetch(`${cfg.cartUrl || `${root}cart`}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    } catch (e) {}
  };

  const addVariantToCart = async (variantId, button, quantity = 1) => {
    if (!variantId || !button || button.disabled) return;
    const buttonLabel = button.querySelector('.mtd-add-button-label');
    const originalLabel = buttonLabel?.textContent || '';
    const originalHTML = button.innerHTML;
    const setButtonStatus = (text) => {
      const liveLabel = button.querySelector('.mtd-add-button-label');
      if (liveLabel) liveLabel.textContent = text;
      else button.textContent = text;
    };
    const restoreButton = () => {
      const liveLabel = button.querySelector('.mtd-add-button-label');
      if (liveLabel && originalLabel) liveLabel.textContent = originalLabel;
      else button.innerHTML = originalHTML;
    };

    button.disabled = true;
    setButtonStatus('Adding…');
    try {
      const response = await fetch(`${cfg.cartAddUrl || `${root}cart/add`}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity || 1) }] })
      });
      if (!response.ok) throw new Error('Cart add failed');
      setButtonStatus('Added To Bag');
      await updateCartCount();
      window.setTimeout(() => {
        restoreButton();
        button.disabled = false;
      }, 1300);
    } catch (e) {
      setButtonStatus('Try Again');
      button.disabled = false;
      window.setTimeout(() => { restoreButton(); }, 1500);
    }
  };

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('[data-add-to-cart]');
    if (addButton) {
      event.preventDefault();
      event.stopPropagation();
      addVariantToCart(addButton.dataset.variantId, addButton);
      return;
    }

    const productCard = event.target.closest('[data-product-card][data-product-url]');
    if (!productCard) return;
    if (event.target.closest('a, button, input, select, textarea, label')) return;
    const productUrl = productCard.dataset.productUrl;
    if (productUrl) window.location.href = productUrl;
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form.mtd-product-buy');
    if (!form) return;
    event.preventDefault();
    const formData = new FormData(form);
    const button = form.querySelector('[data-product-submit]');
    addVariantToCart(formData.get('id'), button, formData.get('quantity') || 1);
  });

  // Cart quantities should never exceed Shopify's tracked inventory for the variant.
  const clampCartQuantity = (input) => {
    if (!input) return;
    const rawMax = input.dataset.inventoryMax;
    const max = rawMax === undefined || rawMax === '' ? null : Number(rawMax);
    let value = Number.parseInt(input.value, 10);
    if (!Number.isFinite(value)) value = 0;
    value = Math.max(0, value);
    if (Number.isFinite(max)) value = Math.min(value, Math.max(0, max));
    input.value = String(value);
  };

  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-cart-quantity-input]');
    if (!input) return;
    clampCartQuantity(input);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-quantity-input]');
    if (!input) return;
    clampCartQuantity(input);
  });

  document.addEventListener('submit', (event) => {
    const cartForm = event.target.closest('form[action*="/cart"]');
    if (!cartForm || cartForm.classList.contains('mtd-product-buy')) return;
    cartForm.querySelectorAll('[data-cart-quantity-input]').forEach(clampCartQuantity);
  }, true);

  // Search + predictive product suggestions.
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchPopover = document.querySelector('[data-search-popover]');
  const searchInput = document.querySelector('[data-predictive-search-input]');
  const searchResults = document.querySelector('[data-predictive-search-results]');
  let searchTimer;

  const closeSearch = () => {
    if (!searchPopover || !searchToggle) return;
    searchPopover.classList.remove('open');
    searchToggle.setAttribute('aria-expanded', 'false');
  };

  searchToggle?.addEventListener('click', () => {
    const open = searchPopover.classList.toggle('open');
    searchToggle.setAttribute('aria-expanded', String(open));
    if (open) window.setTimeout(() => searchInput?.focus(), 50);
  });

  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeSearch(); });
  document.addEventListener('click', (event) => {
    if (!searchPopover?.classList.contains('open')) return;
    if (!searchPopover.contains(event.target) && !searchToggle?.contains(event.target)) closeSearch();
  });

  searchInput?.addEventListener('input', () => {
    window.clearTimeout(searchTimer);
    const query = searchInput.value.trim();
    if (query.length < 2) {
      if (searchResults) searchResults.innerHTML = '';
      return;
    }
    searchTimer = window.setTimeout(async () => {
      try {
        const base = cfg.predictiveSearchUrl || `${root}search/suggest`;
        const url = `${base}.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
        const response = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const data = await response.json();
        const products = data?.resources?.results?.products || [];
        const cards = products.map((product) => {
          const image = product?.featured_image?.url || product?.image || '';
          const imageMarkup = image ? `<img src="${escapeHTML(image)}" alt="">` : '<span></span>';
          const price = product.price ? `<span class="mtd-search-result-price">${escapeHTML(formatPredictivePrice(product.price))}</span>` : '';
          return `<a class="mtd-search-result" href="${escapeHTML(product.url)}">${imageMarkup}<span class="mtd-search-result-title">${escapeHTML(product.title)}</span>${price}</a>`;
        }).join('');
        const allUrl = `${cfg.searchUrl || `${root}search`}?q=${encodeURIComponent(query)}&type=product`;
        searchResults.innerHTML = cards + `<a class="mtd-search-all" href="${allUrl}">View all results</a>`;
      } catch (e) {}
    }, 180);
  });

  // Collection infinite scroll.
  // Shopify's own pagination URL is used as the source of truth, so active
  // filters, sort order and locale/Markets paths are preserved automatically.
  const initInfiniteCollections = (scope = document) => {
    scope.querySelectorAll('[data-infinite-collection]').forEach((collectionRoot) => {
      if (collectionRoot.dataset.infiniteReady === 'true') return;

      const grid = collectionRoot.querySelector('[data-infinite-product-grid]');
      const scrollWrap = collectionRoot.querySelector('[data-infinite-scroll]');
      if (!grid || !scrollWrap) return;

      let nextLink = scrollWrap.querySelector('[data-infinite-next]');
      let sentinel = scrollWrap.querySelector('[data-infinite-sentinel]');
      let statusText = scrollWrap.querySelector('[data-infinite-status-text]');
      let observer = null;
      let loading = false;
      let exhausted = !nextLink;

      const finish = () => {
        exhausted = true;
        loading = false;
        observer?.disconnect();
        scrollWrap.hidden = true;
        scrollWrap.classList.remove('is-loading');
      };

      const loadNextPage = async () => {
        if (loading || exhausted || !nextLink?.href) return;

        loading = true;
        scrollWrap.classList.add('is-loading');
        if (statusText) statusText.textContent = 'Loading more products';

        try {
          const response = await fetch(nextLink.href, {
            headers: {
              'Accept': 'text/html',
              'X-Requested-With': 'XMLHttpRequest'
            }
          });

          if (!response.ok) throw new Error(`Collection page failed: ${response.status}`);

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const incomingRoot = doc.querySelector('[data-infinite-collection]');
          const incomingGrid = incomingRoot?.querySelector('[data-infinite-product-grid]');

          if (!incomingGrid) {
            finish();
            return;
          }

          const incomingProducts = [...incomingGrid.children];
          if (!incomingProducts.length) {
            finish();
            return;
          }

          const fragment = document.createDocumentFragment();
          incomingProducts.forEach((product) => fragment.appendChild(product));
          grid.appendChild(fragment);
          initProductCardSizes(grid);

          const incomingNext = incomingRoot.querySelector('[data-infinite-next]');
          if (incomingNext?.href) {
            // Preserve Shopify's generated next-page URL including filters/sort.
            nextLink.href = incomingNext.href;
            nextLink.setAttribute('href', incomingNext.getAttribute('href') || incomingNext.href);

            loading = false;
            scrollWrap.classList.remove('is-loading');
            if (statusText) statusText.textContent = 'Loading more products';

            // If the new batch is short enough that the sentinel is still
            // visible, the observer will naturally request the following batch.
          } else {
            finish();
          }
        } catch (error) {
          loading = false;
          scrollWrap.classList.remove('is-loading');

          // Do not hammer the endpoint after a temporary network failure.
          // Keep the sentinel active so a later re-entry can retry.
          if (statusText) statusText.textContent = 'Unable to load more products';
        }
      };

      if ('IntersectionObserver' in window && sentinel && nextLink) {
        observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            loadNextPage();
          }
        }, {
          root: null,
          // Start fetching before the shopper physically reaches the end,
          // minimizing the chance they ever see a loading gap.
          rootMargin: '700px 0px 700px 0px',
          threshold: 0
        });

        observer.observe(sentinel);
      } else if (nextLink) {
        // Progressive enhancement fallback for older browsers.
        const onScroll = () => {
          if (loading || exhausted) return;
          const remaining = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
          if (remaining < 900) loadNextPage();
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      collectionRoot.dataset.infiniteReady = 'true';
    });
  };

  initInfiniteCollections();

  // Mobile navigation.
  const menuButton = document.querySelector('[data-mobile-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  menuButton?.addEventListener('click', () => {
    const open = mobileNav.classList.toggle('open');
    menuButton.setAttribute('aria-expanded', String(open));
  });

  // Product image gallery: one large image, clickable thumbnails and arrow navigation.
  const initProductGalleries = (scope = document) => {
    scope.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
      if (gallery.dataset.galleryReady === 'true') return;

      const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
      const prev = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');

      if (!slides.length) return;

      let activeIndex = Math.max(
        0,
        slides.findIndex((slide) => slide.classList.contains('is-active'))
      );

      const activate = (index, { focusThumb = false } = {}) => {
        if (!slides.length) return;
        activeIndex = ((index % slides.length) + slides.length) % slides.length;

        slides.forEach((slide, i) => {
          const active = i === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');

          if (!active) {
            slide.querySelectorAll('video').forEach((video) => {
              try { video.pause(); } catch (e) {}
            });
          }
        });

        thumbs.forEach((thumb, i) => {
          const active = i === activeIndex;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });

        const activeThumb = thumbs[activeIndex];
        if (activeThumb) {
          activeThumb.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
          if (focusThumb) activeThumb.focus({ preventScroll: true });
        }
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          activate(Number(thumb.dataset.galleryIndex || 0));
        });
      });

      prev?.addEventListener('click', () => activate(activeIndex - 1));
      next?.addEventListener('click', () => activate(activeIndex + 1));

      gallery.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          activate(activeIndex - 1, { focusThumb: true });
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          activate(activeIndex + 1, { focusThumb: true });
        }
      });

      gallery.dataset.galleryReady = 'true';
      activate(activeIndex);
    });
  };

  initProductGalleries();

  // Product detail extraction from the Shopify product description.
  // Description values take priority; Liquid metafields/tags remain fallbacks.
  const descriptionToText = (html = '') => {
    const withBreaks = String(html)
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/(p|div|li|tr|h[1-6]|section|article)>/gi, '\n')
      .replace(/<(p|div|li|tr|h[1-6]|section|article)\b[^>]*>/gi, '');
    const doc = new DOMParser().parseFromString(`<div>${withBreaks}</div>`, 'text/html');
    return (doc.body.textContent || '')
      .replace(/\u00a0/g, ' ')
      .replace(/[ \t]+/g, ' ')
      .replace(/\s*\n\s*/g, '\n')
      .replace(/\n{2,}/g, '\n')
      .trim();
  };

  const detailLabelPattern = '(?:tagged\\s+size|size|tag|measurements?|pit\\s*(?:to|-)\\s*pit|p2p|length|condition)';

  const extractDescriptionValue = (text, labels) => {
    const labelPattern = labels.map((label) => label.source || label).join('|');

    // Prefer clean line-based fields such as "Size: Large".
    const lines = String(text || '').split(/\n+/).map((line) => line.trim()).filter(Boolean);
    for (const line of lines) {
      const match = line.match(new RegExp(`^(?:${labelPattern})\\s*(?:[:\\-–—]|\\s)\\s*(.+)$`, 'i'));
      if (match?.[1]) {
        const value = match[1]
          .replace(new RegExp(`\\s+(?=${detailLabelPattern}\\s*[:\\-–—])`, 'i'), '\n')
          .split('\n')[0]
          .trim();
        if (value) return value;
      }
    }

    // Fallback for descriptions where several fields are written on one line.
    const globalMatch = String(text || '').match(
      new RegExp(
        `(?:^|\\s)(?:${labelPattern})\\s*[:\\-–—]\\s*(.*?)(?=\\s+(?:${detailLabelPattern})\\s*[:\\-–—]|$)`,
        'i'
      )
    );
    return globalMatch?.[1]?.trim() || '';
  };

  const populateProductCardSize = (card) => {
    if (!card || card.querySelector('.mtd-size-chip')) return;

    let descriptionHTML = '';
    const descriptionNode = card.querySelector('[data-card-description]');
    if (descriptionNode) {
      try {
        descriptionHTML = JSON.parse(descriptionNode.textContent || '""') || '';
      } catch (e) {
        descriptionHTML = descriptionNode.textContent || '';
      }
    }

    let size = '';
    if (descriptionHTML) {
      const descriptionText = descriptionToText(descriptionHTML);
      size = extractDescriptionValue(descriptionText, [
        'tagged\\s+size',
        'size'
      ]);
    }

    // Description is intentionally checked before metafield/tag fallback.
    if (!size) {
      size = String(card.dataset.cardSizeFallback || '').trim();
    }

    if (!size) return;

    const shell = card.querySelector('.mtd-product-shell');
    if (!shell) return;

    const chip = document.createElement('span');
    chip.className = 'mtd-size-chip';
    chip.textContent = `Size ${size}`;
    shell.prepend(chip);
  };

  const initProductCardSizes = (scope = document) => {
    const cards = [];
    if (scope.matches?.('[data-product-card]')) cards.push(scope);
    scope.querySelectorAll?.('[data-product-card]').forEach((card) => cards.push(card));
    cards.forEach(populateProductCardSize);
  };

  initProductCardSizes();

  const cleanDimension = (value = '') => String(value)
    .trim()
    .replace(/\s*(?:inches?|inch)\b/gi, ' in')
    .replace(/\s+/g, ' ');

  const normalizeMeasurements = (value = '') => {
    const cleaned = String(value)
      .trim()
      .replace(/[×✕]/g, 'x')
      .replace(/\bby\b/gi, 'x')
      .replace(/\s+/g, ' ');

    const pair = cleaned.match(
      /(\d+(?:\.\d+)?\s*(?:"|in\b|inch(?:es)?\b)?)\s*x\s*(\d+(?:\.\d+)?\s*(?:"|in\b|inch(?:es)?\b)?)/i
    );
    if (pair) return `${cleanDimension(pair[1])} x ${cleanDimension(pair[2])}`;

    return cleaned;
  };

  const populateDetailsFromDescription = (productSection) => {
    const descriptionNode = productSection.querySelector('[data-product-description]');
    if (!descriptionNode) return;

    let descriptionHTML = '';
    try {
      descriptionHTML = JSON.parse(descriptionNode.textContent || '""') || '';
    } catch (e) {
      descriptionHTML = descriptionNode.textContent || '';
    }

    const descriptionText = descriptionToText(descriptionHTML);
    if (!descriptionText) return;

    const size = extractDescriptionValue(descriptionText, [
      'tagged\\s+size',
      'size'
    ]);
    const tag = extractDescriptionValue(descriptionText, [
      'tag'
    ]);
    const condition = extractDescriptionValue(descriptionText, [
      'condition'
    ]);

    let measurements = extractDescriptionValue(descriptionText, [
      'measurements?'
    ]);

    // When the description stores width and length separately, combine them
    // into one "__ x __" Measurements value.
    if (!measurements) {
      const pitToPit = extractDescriptionValue(descriptionText, [
        'pit\\s*(?:to|-)\\s*pit',
        'p2p'
      ]);
      const length = extractDescriptionValue(descriptionText, [
        'length'
      ]);
      if (pitToPit && length) {
        measurements = `${cleanDimension(pitToPit)} x ${cleanDimension(length)}`;
      }
    }

    const sizeNode = productSection.querySelector('[data-product-size]');
    const tagNode = productSection.querySelector('[data-product-tag]');
    const measurementsNode = productSection.querySelector('[data-product-measurements]');
    const conditionNode = productSection.querySelector('[data-product-condition]');

    if (size && sizeNode) sizeNode.textContent = size;
    if (tag && tagNode) tagNode.textContent = tag;
    if (measurements && measurementsNode) measurementsNode.textContent = normalizeMeasurements(measurements);
    if (condition && conditionNode) conditionNode.textContent = condition;
  };

  document.querySelectorAll('[data-main-product]').forEach((productSection) => {
    populateDetailsFromDescription(productSection);
  });

  // Variant selection updates product page pricing, size and availability.
  document.querySelectorAll('[data-main-product]').forEach((productSection) => {
    const select = productSection.querySelector('[data-variant-select]');
    const variantsNode = productSection.querySelector('[data-product-variants]');
    const optionsNode = productSection.querySelector('[data-product-options]');
    if (!select || !variantsNode) return;
    let variants = [];
    let optionNames = [];
    try { variants = JSON.parse(variantsNode.textContent); } catch (e) {}
    try { optionNames = JSON.parse(optionsNode?.textContent || '[]'); } catch (e) {}
    const sizeIndex = optionNames.findIndex((name) => String(name).toLowerCase().includes('size'));

    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === String(select.value));
      if (!variant) return;
      const priceWrap = productSection.querySelector('[data-main-price]');
      if (priceWrap) {
        if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
          priceWrap.innerHTML = `<div class="mtd-product-main-sale"><span class="mtd-price-original">${formatMoney(variant.compare_at_price)}</span><span class="mtd-price-sale">${formatMoney(variant.price)}</span></div>`;
        } else {
          priceWrap.innerHTML = `<div class="mtd-product-main-price">${formatMoney(variant.price)}</div>`;
        }
      }
      const sizeNode = productSection.querySelector('[data-product-size]');
      if (sizeNode && sizeIndex >= 0) sizeNode.textContent = variant.options?.[sizeIndex] || '—';
      const submit = productSection.querySelector('[data-product-submit]');
      if (submit) {
        submit.disabled = !variant.available;
        const buttonPriceMarkup = variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)
          ? `<span class="mtd-add-button-price"><span class="mtd-add-button-compare">${formatMoney(variant.compare_at_price)}</span><span class="mtd-add-button-sale">${formatMoney(variant.price)}</span></span>`
          : `<span class="mtd-add-button-price"><span class="mtd-add-button-current">${formatMoney(variant.price)}</span></span>`;
        submit.innerHTML = `${buttonPriceMarkup}<span class="mtd-add-button-divider" aria-hidden="true"></span><span class="mtd-add-button-label">${variant.available ? 'Add To Cart' : 'Sold Out'}</span>`;
      }
    });
  });

  // Shopify Product Recommendations API + stricter storefront relevance ranking.
  // Shopify provides the candidate set; we then use the product's own merchandising
  // language to choose the strongest few rather than blindly showing every returned result.
  const recStopWords = new Set([
    'a','an','and','are','as','at','be','by','for','from','in','is','it','of','on','or','the','to','with',
    'vintage','tee','tees','tshirt','tshirts','shirt','shirts','graphic','graphics','cotton','size',
    'condition','measurements','measurement','pit','length','tag','tagged','one','piece','pieces'
  ]);

  const recPhraseWeights = new Map([
    ['world cup', 14],
    ['premier league', 10],
    ['champions league', 10],
    ['la liga', 10],
    ['serie a', 10],
    ['j league', 10],
    ['major league soccer', 10],
    ['all over print', 11],
    ['all-over-print', 11],
    ['aop', 12],
    ['nba', 10],
    ['nfl', 10],
    ['mlb', 10],
    ['nhl', 10],
    ['mls', 10],
    ['fifa', 8],
    ['olympics', 8],
    ['champions', 5],
    ['champion', 5],
    ['apex', 6],
    ['kick', 5],
    ['salem', 7],
    ['sportswear', 2],
    ['jersey', 5]
  ]);

  const normalizeRecText = (value = '') => String(value)
    .toLowerCase()
    .replace(/&amp;/g, ' and ')
    .replace(/[’']/g, '')
    .replace(/t[\s-]?shirt/g, ' tshirt ')
    .replace(/all[\s-]?over[\s-]?print/g, ' all over print aop ')
    .replace(/\bfutbol\b|\bsoccer\b/g, ' football ')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const recTokens = (value = '') => {
    const normalized = normalizeRecText(value);
    return normalized.split(' ').filter((token) => {
      if (!token || recStopWords.has(token)) return false;
      if (/^\d+(?:\.\d+)?$/.test(token)) return /^(19|20)\d{2}$/.test(token);
      return token.length > 1;
    });
  };

  const recSet = (value = '') => new Set(recTokens(value));

  const overlapCount = (left, right) => {
    let count = 0;
    left.forEach((value) => { if (right.has(value)) count += 1; });
    return count;
  };

  const phraseScore = (currentText, candidateText) => {
    const current = normalizeRecText(currentText);
    const candidate = normalizeRecText(candidateText);
    let score = 0;
    recPhraseWeights.forEach((weight, phrase) => {
      if (current.includes(phrase) && candidate.includes(phrase)) score += weight;
    });
    return score;
  };

  const yearTokens = (value = '') => new Set(
    recTokens(value).filter((token) => /^(19|20)\d{2}$/.test(token))
  );

  const scoreRecommendation = (context, card, originalIndex) => {
    const candidate = {
      title: card.dataset.recTitle || '',
      tags: (card.dataset.recTags || '').split('|').filter(Boolean),
      type: card.dataset.recType || '',
      vendor: card.dataset.recVendor || '',
      description: card.dataset.recDescription || '',
      imageAlt: card.dataset.recImageAlt || ''
    };

    const currentTitle = recSet(context.title);
    const candidateTitle = recSet(candidate.title);
    const sharedTitleTokens = [...currentTitle].filter((token) => candidateTitle.has(token));

    let score = 0;

    // Shopify already orders the candidate pool by relevance. Keep that as a
    // meaningful tie-breaker while allowing stronger catalog similarity to win.
    score += Math.max(0, 10 - originalIndex) * 1.35;

    sharedTitleTokens.forEach((token) => {
      if (/^(19|20)\d{2}$/.test(token)) score += 9;
      else if (token === 'aop') score += 10;
      else if (token.length >= 7) score += 5;
      else if (token.length >= 4) score += 3.5;
      else score += 2;
    });

    score += phraseScore(context.title, candidate.title);

    const currentYears = yearTokens(context.title);
    const candidateYears = yearTokens(candidate.title);
    if (overlapCount(currentYears, candidateYears) > 0) score += 8;

    const currentTags = new Set((context.tags || []).map(normalizeRecText).filter(Boolean));
    const candidateTags = new Set(candidate.tags.map(normalizeRecText).filter(Boolean));
    score += overlapCount(currentTags, candidateTags) * 7;

    if (context.type && candidate.type && normalizeRecText(context.type) === normalizeRecText(candidate.type)) {
      score += 8;
    }

    if (context.vendor && candidate.vendor && normalizeRecText(context.vendor) === normalizeRecText(candidate.vendor)) {
      score += 2;
    }

    const currentDescription = recSet(context.description || '');
    const candidateDescription = recSet(candidate.description || '');
    score += Math.min(8, overlapCount(currentDescription, candidateDescription) * 0.8);

    const currentImageAlt = recSet(context.image_alt || '');
    const candidateImageAlt = recSet(candidate.imageAlt || '');
    score += Math.min(5, overlapCount(currentImageAlt, candidateImageAlt) * 1.5);

    // Penalize a candidate that shares essentially no merchandising language.
    if (sharedTitleTokens.length === 0 &&
        overlapCount(currentTags, candidateTags) === 0 &&
        (!context.type || !candidate.type || normalizeRecText(context.type) !== normalizeRecText(candidate.type))) {
      score -= 6;
    }

    return score;
  };

  const rankRecommendationCards = (section) => {
    const contextNode = section.querySelector('[data-recommendation-context]');
    const grid = section.querySelector('[data-recommendation-grid]');
    if (!contextNode || !grid) return;

    let context = {};
    try { context = JSON.parse(contextNode.textContent || '{}'); } catch (e) {}

    const requestedCount = 8;
    const cards = [...grid.querySelectorAll('[data-recommendation-card]')];

    const ranked = cards.map((card, index) => ({
      card,
      index,
      score: scoreRecommendation(context, card, index)
    })).sort((a, b) => {
      if (b.score !== a.score) return b.score - a.score;
      return a.index - b.index;
    });

    ranked.forEach(({ card }, index) => {
      card.hidden = index >= requestedCount;
      grid.appendChild(card);
    });

    // Useful for debugging in the browser without changing the storefront UI.
    section.dataset.rankingApplied = 'true';
  };

  const initRecommendationCarousel = (section) => {
    const carousel = section.querySelector('[data-recommendation-carousel]');
    const viewport = carousel?.querySelector('[data-rec-viewport]');
    const track = carousel?.querySelector('[data-rec-track]');
    const prev = carousel?.querySelector('[data-rec-prev]');
    const next = carousel?.querySelector('[data-rec-next]');
    const currentNode = carousel?.querySelector('[data-rec-page-current]');
    const totalNode = carousel?.querySelector('[data-rec-page-total]');

    if (!carousel || !viewport || !track || carousel.dataset.carouselReady === 'true') return;

    const cards = [...track.querySelectorAll('[data-recommendation-card]')]
      .filter((card) => !card.hidden)
      .slice(0, 8);

    cards.forEach((card) => { card.hidden = false; });

    let page = 0;

    // Desktop = 4 cards, tablet/mobile = 2 cards.
    // This must match the CSS flex-basis rules exactly.
    const visibleCount = () => {
      if (window.matchMedia('(max-width: 1050px)').matches) return 2;
      return 4;
    };

    const totalPages = () => Math.max(1, Math.ceil(cards.length / visibleCount()));

    const trackGap = () => {
      const styles = window.getComputedStyle(track);
      const rawGap = styles.columnGap || styles.gap || '0';
      const parsed = parseFloat(rawGap);
      return Number.isFinite(parsed) ? parsed : 0;
    };

    const render = ({ animate = true } = {}) => {
      const pages = totalPages();
      page = ((page % pages) + pages) % pages;

      // The next page begins one viewport width plus the inter-page flex gap
      // after the current page. Reading the actual computed gap prevents
      // cumulative drift at mobile breakpoints.
      const offset = page * (viewport.clientWidth + trackGap());

      if (!animate) {
        track.style.transition = 'none';
      }

      track.style.transform = `translate3d(${-offset}px,0,0)`;

      if (!animate) {
        requestAnimationFrame(() => {
          track.style.transition = '';
        });
      }

      if (currentNode) currentNode.textContent = String(page + 1);
      if (totalNode) totalNode.textContent = String(pages);

      // Carousel wraps forever, so arrows remain active whenever >1 page exists.
      if (prev) prev.disabled = pages <= 1;
      if (next) next.disabled = pages <= 1;

      const controls = carousel.querySelector('.mtd-rec-carousel-controls');
      if (controls) controls.hidden = pages <= 1;
    };

    const goPrevious = () => {
      page -= 1;
      render();
    };

    const goNext = () => {
      page += 1;
      render();
    };

    prev?.addEventListener('click', goPrevious);
    next?.addEventListener('click', goNext);

    // Basic swipe support while keeping the arrow controls.
    let touchStartX = null;
    viewport.addEventListener('touchstart', (event) => {
      touchStartX = event.touches?.[0]?.clientX ?? null;
    }, { passive: true });

    viewport.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const touchEndX = event.changedTouches?.[0]?.clientX ?? touchStartX;
      const delta = touchEndX - touchStartX;
      touchStartX = null;

      if (Math.abs(delta) < 35) return;
      if (delta < 0) goNext();
      else goPrevious();
    }, { passive: true });

    let resizeTimer;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        // Recalculate exact viewport/gap math after responsive layout changes.
        render({ animate: false });
      }, 90);
    });

    carousel.dataset.carouselReady = 'true';
    render({ animate: false });
  };

  document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
    const url = section.dataset.url;
    if (!url) return;
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Recommendations failed');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const replacement = doc.querySelector('[data-product-recommendations]');
      if (replacement && replacement.innerHTML.trim()) {
        section.innerHTML = replacement.innerHTML;
        initProductCardSizes(section);
        rankRecommendationCards(section);
        initRecommendationCarousel(section);
      } else {
        section.closest('.mtd-product-after')?.setAttribute('hidden', 'hidden');
      }
    } catch (e) {
      section.closest('.mtd-product-after')?.setAttribute('hidden', 'hidden');
    }
  });

  // Recently viewed: visitor-specific, newest first, de-duplicated, current product excluded.
  // History persists in localStorage, falls back to sessionStorage, and gracefully skips
  // products that were deleted/unpublished after being viewed.
  const RECENT_KEY = 'mtd_recently_viewed_v1';
  const RECENT_MAX = 20;
  const recentProductCache = new Map();
  let recentMemoryHistory = [];

  const getRecentStorage = () => {
    const stores = [];
    try { stores.push(window.localStorage); } catch (e) {}
    try { stores.push(window.sessionStorage); } catch (e) {}

    for (const store of stores) {
      if (!store) continue;
      try {
        const testKey = `${RECENT_KEY}_test`;
        store.setItem(testKey, '1');
        store.removeItem(testKey);
        return store;
      } catch (e) {}
    }
    return null;
  };

  const recentStorage = getRecentStorage();

  const normalizeHistory = (value) => {
    if (!Array.isArray(value)) return [];
    const seen = new Set();
    const handles = [];

    value.forEach((entry) => {
      // Backward compatible with any future/older object-shaped history entries.
      const handle = typeof entry === 'string' ? entry : entry?.handle;
      const normalized = String(handle || '').trim();
      if (!normalized || seen.has(normalized)) return;
      seen.add(normalized);
      handles.push(normalized);
    });

    return handles.slice(0, RECENT_MAX);
  };

  const getHistory = () => {
    if (!recentStorage) return normalizeHistory(recentMemoryHistory);
    try {
      return normalizeHistory(JSON.parse(recentStorage.getItem(RECENT_KEY) || '[]'));
    } catch (e) {
      return [];
    }
  };

  const saveHistory = (handles) => {
    const normalized = normalizeHistory(handles);
    recentMemoryHistory = normalized;
    if (!recentStorage) return;
    try { recentStorage.setItem(RECENT_KEY, JSON.stringify(normalized)); } catch (e) {}
  };

  const recordRecentlyViewed = (handle) => {
    const normalizedHandle = String(handle || '').trim();
    if (!normalizedHandle) return;
    const history = getHistory().filter((item) => item !== normalizedHandle);
    history.unshift(normalizedHandle);
    saveHistory(history);
  };

  const productJSON = async (handle) => {
    const normalizedHandle = String(handle || '').trim();
    if (!normalizedHandle) return null;
    if (recentProductCache.has(normalizedHandle)) return recentProductCache.get(normalizedHandle);

    const request = fetch(`${root}products/${encodeURIComponent(normalizedHandle)}.js`, {
      headers: { Accept: 'application/json' }
    }).then(async (response) => {
      if (!response.ok) throw new Error(`Product fetch failed: ${response.status}`);
      return response.json();
    }).catch(() => null);

    recentProductCache.set(normalizedHandle, request);
    return request;
  };

  const sizeFromProductJSON = (product, variant) => {
    const options = product.options || [];
    const index = options.findIndex((option) => {
      const name = typeof option === 'string' ? option : option?.name;
      return String(name || '').toLowerCase().includes('size');
    });

    if (index >= 0) {
      const optionSize = variant?.options?.[index]
        || (typeof options[index] === 'object' ? options[index]?.values?.[0] : '');
      if (optionSize) return String(optionSize).trim();
    }

    const descriptionText = descriptionToText(product?.description || '');
    const descriptionSize = extractDescriptionValue(descriptionText, [
      'tagged\\s+size',
      'size'
    ]);
    if (descriptionSize) return descriptionSize;

    const rawTags = Array.isArray(product?.tags)
      ? product.tags
      : String(product?.tags || '').split(',');

    for (const rawTag of rawTags) {
      const tag = String(rawTag || '').trim();
      const match = tag.match(/^(?:tagged\s+size|size)\s*[:\-–—]\s*(.+)$/i);
      if (match?.[1]) return match[1].trim();
    }

    return '';
  };

  const recentProductUrl = (product) => `${root}products/${encodeURIComponent(product.handle)}`;

  const recentCardHTML = (product) => {
    if (!product?.handle) return '';
    const variants = product.variants || [];
    const variant = variants.find((item) => item.available) || variants[0];
    if (!variant) return '';

    const image1 = product.featured_image || product.images?.[0] || '';
    const image2 = product.images?.[1] || '';
    const size = sizeFromProductJSON(product, variant);
    const compareAt = Number(variant.compare_at_price || 0);
    const currentPrice = Number(variant.price || 0);
    const salePercent = compareAt > currentPrice && compareAt > 0
      ? Math.ceil(((compareAt - currentPrice) / compareAt) * 100)
      : 0;
    const saleBadge = salePercent > 0
      ? `<span class="mtd-sale-badge" aria-label="Sale ${salePercent} percent off"><span class="mtd-sale-badge-label">Sale</span><span class="mtd-sale-badge-percent">-${salePercent}%</span></span>`
      : '';
    const productUrl = recentProductUrl(product);
    const buttonPriceMarkup = variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)
      ? `<span class="mtd-add-button-price"><span class="mtd-add-button-compare">${formatMoney(variant.compare_at_price)}</span><span class="mtd-add-button-sale">${formatMoney(variant.price)}</span></span>`
      : `<span class="mtd-add-button-price"><span class="mtd-add-button-current">${formatMoney(variant.price)}</span></span>`;
    const primaryImage = image1
      ? `<img class="mtd-product-image mtd-product-image--primary" src="${escapeHTML(image1)}" alt="${escapeHTML(product.title)}" loading="lazy">`
      : '';
    const secondImage = image2
      ? `<img class="mtd-product-image mtd-product-image--secondary" src="${escapeHTML(image2)}" alt="" loading="lazy">`
      : '';

    return `<article class="mtd-product-card" data-product-card data-product-handle="${escapeHTML(product.handle)}" data-product-url="${escapeHTML(productUrl)}"><div class="mtd-product-shell">${saleBadge}${size ? `<span class="mtd-size-chip">Size ${escapeHTML(size)}</span>` : ''}<a class="mtd-product-media" href="${escapeHTML(productUrl)}">${primaryImage}${secondImage}</a><div class="mtd-product-meta"><div class="mtd-product-info-panel"><div class="mtd-product-name"><a href="${escapeHTML(productUrl)}">${escapeHTML(product.title)}</a></div></div><button class="mtd-add-button mtd-add-button--priced" type="button" data-add-to-cart data-variant-id="${variant.id}" ${variant.available ? '' : 'disabled'}>${buttonPriceMarkup}<span class="mtd-add-button-divider" aria-hidden="true"></span><span class="mtd-add-button-label">${variant.available ? 'Add To Cart' : 'Sold Out'}</span></button></div></div></article>`;
  };

  const loadRecentProducts = async (handles, limit) => {
    const products = [];
    let cursor = 0;
    const safeLimit = Math.max(1, Number(limit) || 4);

    // Fetch in small batches. If an old product was deleted/unpublished, continue farther
    // down history so the section still fills to the requested count when possible.
    while (cursor < handles.length && products.length < safeLimit) {
      const remaining = safeLimit - products.length;
      const batchSize = Math.max(4, remaining + 2);
      const batch = handles.slice(cursor, cursor + batchSize);
      cursor += batch.length;

      const results = await Promise.all(batch.map((handle) => productJSON(handle)));
      for (const product of results) {
        if (!product?.handle) continue;
        products.push(product);
        if (products.length >= safeLimit) break;
      }
    }

    return products;
  };

  const renderRecentlyViewedSection = async (section, history, currentHandle) => {
    if (!section) return;
    const grid = section.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    const limit = Math.max(1, Number(section.dataset.limit || 4));
    const candidates = normalizeHistory(history).filter((handle) => handle !== currentHandle);
    const designMode = Boolean(window.Shopify?.designMode);

    grid.setAttribute('aria-busy', 'true');

    if (!candidates.length) {
      grid.removeAttribute('aria-busy');
      if (designMode) {
        section.hidden = false;
        grid.innerHTML = '<div class="mtd-recent-empty">Recently viewed products will appear here as you browse.</div>';
      } else {
        section.hidden = true;
      }
      return;
    }

    const products = await loadRecentProducts(candidates, limit);
    grid.removeAttribute('aria-busy');

    if (!products.length) {
      if (designMode) {
        section.hidden = false;
        grid.innerHTML = '<div class="mtd-recent-empty">Recently viewed products will appear here as you browse.</div>';
      } else {
        section.hidden = true;
      }
      return;
    }

    section.hidden = false;
    grid.innerHTML = products.map(recentCardHTML).filter(Boolean).join('');
  };

  const initRecentlyViewed = (scope = document) => {
    const currentProduct = document.querySelector('[data-main-product]');
    const currentHandle = currentProduct?.dataset.productHandle || '';
    if (!currentHandle) return;

    // Snapshot previous history before recording the current page. This guarantees that
    // the current product is never shown inside its own Recently Viewed section.
    const previousHistory = getHistory().filter((handle) => handle !== currentHandle);

    const sections = [];
    if (scope.matches?.('[data-recently-viewed]')) sections.push(scope);
    scope.querySelectorAll?.('[data-recently-viewed]').forEach((section) => sections.push(section));

    sections.forEach((section) => {
      renderRecentlyViewedSection(section, previousHistory, currentHandle);
    });

    recordRecentlyViewed(currentHandle);
  };

  initRecentlyViewed();

  // Pages restored from the browser back/forward cache don't rerun deferred scripts,
  // so refresh the list when the page becomes active again.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) initRecentlyViewed(document);
  });

  // Keep another open tab in sync when browsing history changes there.
  window.addEventListener('storage', (event) => {
    if (event.key === RECENT_KEY) initRecentlyViewed(document);
  });
  equalizeHeroButtons();

  let heroButtonResizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(heroButtonResizeTimer);
    heroButtonResizeTimer = window.setTimeout(() => equalizeHeroButtons(), 80);
  });

  document.addEventListener('shopify:section:load', (event) => {
    equalizeHeroButtons(event.target);
    initProductCardSizes(event.target);
    initInfiniteCollections(event.target);
    initProductGalleries(event.target);
    event.target.querySelectorAll?.('[data-product-recommendations]').forEach((section) => {
      rankRecommendationCards(section);
      initRecommendationCarousel(section);
    });
    event.target.querySelectorAll?.('[data-main-product]').forEach((productSection) => {
      populateDetailsFromDescription(productSection);
    });
    if (event.target.matches?.('[data-recently-viewed]') || event.target.querySelector?.('[data-recently-viewed]') || event.target.querySelector?.('[data-main-product]')) {
      initRecentlyViewed(document);
    }
  });

})();
